export default class GraficoOcupacion {
  constructor(canvas) {
    this.canvas = canvas;
  }

  cargarGrafico() {
    const data = [this.canvas.dataset.ocupadas, this.canvas.dataset.libres];
    const enableTooltips = this.canvas.dataset.tooltips === 'true';
    const ctx = this.canvas.getContext('2d');
    /* global Chart, ChartDataLabels */
    /* eslint no-new: "off" */
    new Chart(ctx, {
      plugins: [ChartDataLabels],
      // TODO: #3400 I18n
      type: 'doughnut',
      data: {
        labels: ['Ocupados', 'Libres'],
        datasets: [{
          data,
          backgroundColor: [
            '#fe1d12',
            '#d1dade',
            // '#83d086'
          ],
        }],
      },
      options: {
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: enableTooltips,
        },
        plugins: {
          datalabels: {
            color: [
              '#FFF',
              '#5e5e5e',
            ],
          },
        },
        responsive: false,
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
  }
}
